module.exports = __webpack_public_path__ + "img/Frame_18.cda141ed.png";